import "@/scss/styles.scss";
import { getGlobal } from "@/functions/getGlobal";
import { Suspense } from "react";
import { SiteFooter, SiteHeader } from "@/ui";
import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "../../.sourceflow/metadata.json";
import { useRouter } from "next/router";

export default function App({ Component, pageProps }) {
  const global = getGlobal();
  const router = useRouter();
  const isComponentsPage = router.pathname === "/components";

  return isComponentsPage ? (
    <>
      <Suspense>
        <SiteHeader className={global["_theme.header.classes"]} />
        <main className="flex-grow-1">
          <Component {...pageProps} />
        </main>
        <SiteFooter className={global["_theme.footer.classes"]} />
      </Suspense>
    </>
  ) : (
    <Suspense>
      <SourceFlowHead metaObject={metaObject} addTracker={true} cookieExpiryTime={3000}>
        {pageProps?.meta?.title && <title>{pageProps.meta.title}</title>}
      </SourceFlowHead>
      <SiteHeader className={global["_theme.header.classes"]} />
      <main className="flex-grow-1">
        <Component {...pageProps} />
      </main>
      <SiteFooter className={global["_theme.footer.classes"]} />
    </Suspense>
  );
}
